import React from "react"
import PropTypes from "prop-types"
import { Grid } from "semantic-ui-react"
import EmployeeCard from "./EmployeeCard"
import { contains } from "ramda"

const EmployeesHolder = (props) => {
  const {
    employees,
    loadingEmployeeIds,
    storeOptions,
    deleteEmployee,
    editEmployee,
  } = props

  const cards = employees.map((e) => (
    <Grid.Column key={e.employeeId} computer={8} tablet={16}>
      <EmployeeCard
        {...e}
        storeOptions={storeOptions}
        deleteEmployee={deleteEmployee}
        editEmployee={editEmployee}
        isLoading={contains(e.employeeId, loadingEmployeeIds)}
      />
    </Grid.Column>
  ))
  return <Grid data-test="mainGrid">{cards}</Grid>
}

export default EmployeesHolder

EmployeesHolder.propTypes = {
  employees: PropTypes.arrayOf(
    PropTypes.shape({
      employeeId: PropTypes.number,
      firstName: PropTypes.string,
      middleName: PropTypes.string,
      lastName: PropTypes.string,
      login: PropTypes.string,
      roles: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number,
          name: PropTypes.string,
        }),
      ),
      stores: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number,
          name: PropTypes.string,
        }),
      ),
    }),
  ),
  loadingEmployeeIds: PropTypes.arrayOf(PropTypes.number),
  createEmployee: PropTypes.func,
  deleteEmployee: PropTypes.func,
  editEmployee: PropTypes.func,
  storeOptions: PropTypes.arrayOf(PropTypes.object),
}
